import { of } from "rxjs";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";

import { authLoginAsyncAction } from "./authActions";

export const authLoginEpic = (action$, state$, { auth }) =>
	action$.pipe(
		ofType(authLoginAsyncAction.request().type),
		switchMap(({ payload }) =>
			auth.doLogin(payload).pipe(
				map(({ response }) =>
					authLoginAsyncAction.success(response.accessToken)
				),
				catchError(({ response }) =>
					of(authLoginAsyncAction.failure(response.message))
				)
			)
		)
	);
